// FullScreenLightBox

import img1 from '../../images/portfolio2/image1.png'
import img2 from '../../images/portfolio2/image2.png'
import img3 from '../../images/portfolio2/image3.png'
import img4 from '../../images/portfolio2/image4.png'
import img5 from '../../images/portfolio2/image5.png'
import img5_1 from '../../images/portfolio2/image5_1.png'
import img6 from '../../images/portfolio2/image6.png'
import img7 from '../../images/portfolio2/image7.png'
import img8 from '../../images/portfolio2/image8.png'
import img9 from '../../images/portfolio2/image9.png'
import img10 from '../../images/portfolio2/image10.png'
import img11 from '../../images/portfolio2/image11.png'
import img12 from '../../images/portfolio2/image12.png'
import img13 from '../../images/portfolio2/image13.png'
import img14 from '../../images/portfolio2/image14.png'
import img15 from '../../images/portfolio2/image15.png'
import img16 from '../../images/portfolio2/image16.png'
import img17 from '../../images/portfolio2/image17.png'
import img18 from '../../images/portfolio2/image18.png'
import img19 from '../../images/portfolio2/image19.png'
import img20 from '../../images/portfolio2/image20.png'
import img21 from '../../images/portfolio2/image21.png'
import img22 from '../../images/portfolio2/image22.png'
import img23 from '../../images/portfolio2/image23.png'
import img24 from '../../images/portfolio2/image24.png'
import img25 from '../../images/portfolio2/image25.png'
import image1 from '../../images/portfolio2/Skiny/img1.png'
import image2 from '../../images/portfolio2/Skiny/img2.png'
import image3 from '../../images/portfolio2/Skiny/img3.png'
import image4 from '../../images/portfolio2/Skiny/img4.png'
import image5 from '../../images/portfolio2/Skiny/img5.png'
import image6 from '../../images/portfolio2/Skiny/img6.png'
import image7 from '../../images/portfolio2/Skiny/img7.png'
import image8 from '../../images/portfolio2/Skiny/img8.png'
import image9 from '../../images/portfolio2/Skiny/img9.png'
import image10 from '../../images/portfolio2/Skiny/img10.png'
import image11 from '../../images/portfolio2/Skiny/img11.png'

// SmallerSizePorfolio

import img1_2 from '../../images/portfolio/image1.png'
import img2_2 from '../../images/portfolio/image2.png'
import img3_2 from '../../images/portfolio/image3.png'
import img4_2 from '../../images/portfolio/image4.png'
import img5_2 from '../../images/portfolio/image5.png'
import img5_1_2 from '../../images/portfolio/image5_1.png'
import img6_2 from '../../images/portfolio/image6.png'
import img7_2 from '../../images/portfolio/image7.png'
import img8_2 from '../../images/portfolio/image8.png'
import img9_2 from '../../images/portfolio/image9.png'
import img10_2 from '../../images/portfolio/image10.png'
import img11_2 from '../../images/portfolio/image11.png'
import img12_2 from '../../images/portfolio/image12.png'
import img13_2 from '../../images/portfolio/image13.png'
import img14_2 from '../../images/portfolio/image14.png'
import img15_2 from '../../images/portfolio/image15.png'
import img16_2 from '../../images/portfolio/image16.png'
import img17_2 from '../../images/portfolio/image17.png'
import img18_2 from '../../images/portfolio/image18.png'
import img19_2 from '../../images/portfolio/image19.png'
import img20_2 from '../../images/portfolio/image20.png'
import img21_2 from '../../images/portfolio/image21.png'
import img22_2 from '../../images/portfolio/image22.png'
import img23_2 from '../../images/portfolio/image23.png'
import img24_2 from '../../images/portfolio/image24.png'
import img25_2 from '../../images/portfolio/image25.png'
import image1_2 from '../../images/portfolio/Skiny/img1.png'
import image2_2 from '../../images/portfolio/Skiny/img2.png'
import image3_2 from '../../images/portfolio/Skiny/img3.png'
import image4_2 from '../../images/portfolio/Skiny/img4.png'
import image5_2 from '../../images/portfolio/Skiny/img5.png'
import image6_2 from '../../images/portfolio/Skiny/img6.png'
import image7_2 from '../../images/portfolio/Skiny/img7.png'
import image8_2 from '../../images/portfolio/Skiny/img8.png'
import image9_2 from '../../images/portfolio/Skiny/img9.png'
import image10_2 from '../../images/portfolio/Skiny/img10.png'
import image11_2 from '../../images/portfolio/Skiny/img11.png'


export const PortfolioData = [
    {
        title: 'Collegiate Church of St. Mary and St. Alexius',
        image: img1,
        image_full: img1_2,
        alt: 'Collegiate Church of St. Mary and St. Alexius'
    },
    {
        title: 'The Palace on the Isle',
        image: img2,
        image_full: img2_2,
        alt: 'The Palace on the Isle'
    },
    {
        title: 'The Crane from Gdańsk',
        image: img3,
        image_full: img3_2,
        alt: 'The Crane from Gdańsk'
    },
    {
        title: 'Nieborów Palace',
        image: img4,
        image_full: img4_2,
        alt: 'Nieborów Palace'
    }
]


export const PortfolioData2 = [
    {
        title: '',
        image: img5,
        image_full: img5_2,
        alt: 'Portfolio image'
    },
    {
        title: 'Cyber World',
        image: img5_1,
        image_full: img5_1_2,
        alt: 'Cyber World'
    },
    {
        title: 'Aladdins Palace',
        image: img6,
        image_full: img6_2,
        alt: 'Aladdins Palace'
    },
    {
        title: 'Tornhan Castle',
        image: img7,
        image_full: img7_2,
        alt: 'Tornhan Castle'
    },
    {
        title: '',
        image: img8,
        image_full: img8_2,
        alt: 'Portfolio image'
    },
    {
        title: 'Elden Castle',
        image: img9,
        image_full: img9_2,
        alt: 'Elden Castle'
    },
    {
        title: '',
        image: img10,
        image_full: img10_2,
        alt: 'Portfolio image'
    },
    {
        title: '',
        image: img11,
        image_full: img11_2,
        alt: 'Portfolio image'
    },
    {
        title: 'Palazzo della Borsa Valori',
        image: img12,
        image_full: img12_2,
        alt: 'Palazzo della Borsa Valori'
    },
    {
        title: 'In the Garden of Eden',
        image: img13,
        image_full: img13_2,
        alt: 'In the Garden of Eden'
    },
    {
        title: 'Angels Palace',
        image: img14,
        image_full: img14_2,
        alt: 'Angels Palace'
    },
    {
        title: 'Domum Sabuleum',
        image: img15,
        image_full: img15_2,
        alt: 'Domum Sabuleum'
    },
    {
        title: 'Pirate Skyblock',
        image: img16,
        image_full: img16_2,
        alt: 'Pirate Skyblock'
    },
    {
        title: 'Buckingham Palace',
        image: img17,
        image_full: img17_2,
        alt: 'Buckingham Palace'
    },
    {
        title: 'Castle Retreat - Marketplace Content',
        image: img18,
        image_full: img18_2,
        alt: 'Castle Retreat - Marketplace Content'
    },
    {
        title: 'Towering Landscape - Grarantanna Contest',
        image: img19,
        image_full: img19_2,
        alt: 'Towering Landscape - Grarantanna Contest'
    },
    {
        title: 'Rzeszów Town Hall',
        image: img20,
        image_full: img20_2,
        alt: 'Rzeszów Town Hall'
    },
    {
        title: 'White Pavilion - The Royal Łazienki Park',
        image: img21,
        image_full: img21_2,
        alt: 'White Pavilion - The Royal Łazienki Park'
    },
    {
        title: 'Pless Castle - The Castle Museum in Pszczyna',
        image: img22,
        image_full: img22_2,
        alt: 'Pless Castle - The Castle Museum in Pszczyna'
    },
    {
        title: 'The Warsaw Rising Museum',
        image: img23,
        image_full: img23_2,
        alt: 'The Warsaw Rising Museum'
    },
    {
        title: 'Castle Lobrov',
        image: img24,
        image_full: img24_2,
        alt: 'Castle Lobrov'
    },
    {
        title: '',
        image: img25,
        image_full: img25_2,
        alt: 'Portfolio image'
    },
]

export const PortfolioData3 = [
    {
        title: 'Anime Clan',
        image: image1,
        image_full: image1_2,
        alt: 'Anime Clan'
    }, 
    {
        title: 'Emo Squad',
        image: image2,
        image_full: image2_2,
        alt: 'Emo Squad'
    }, 
    {
        title: 'Anime Rockstart',
        image: image3,
        image_full: image3_2,
        alt: 'Anime Rockstar'
    },
    {
        title: 'Black Outfits',
        image: image4,
        image_full: image4_2,
        alt: 'Black Outfits'
    },
    {
        title: 'Halloween 2022',
        image: image5,
        image_full: image5_2,
        alt: 'Halloween 2022'
    },
    {
        title: 'Rainbow Legend',
        image: image6,
        image_full: image6_2,
        alt: 'Rainbow Legend'
    },
    {
        title: 'Ultimate Heroes',
        image: image7,
        image_full: image7_2,
        alt: 'Ultimate Heroes'
    },
    {
        title: 'Wardens',
        image: image8,
        image_full: image8_2,
        alt: 'Wardens'
    },
    {
        title: 'Plasma Demons',
        image: image9,
        image_full: image9_2,
        alt: 'Plasma Demons'
    },
    {
        title: 'K-Pop Fans',
        image: image10,
        image_full: image10_2,
        alt: 'K-Pop Fans'
    },
    {
        title: 'Shadows',
        image: image11,
        image_full: image11_2,
        alt: 'Shadows'
    },
]